const faqItems = [
  {
    q: '宅男视频需要付费吗？',
    a: '完全免费！宅男视频接入久久视频、小蓝视频、豆花视频等平台资源，所有内容均免费观看，无需任何付费或会员。我们致力于为用户提供零门槛的流畅观影体验。',
  },
  {
    q: '为什么会比其他视频网站更流畅不卡顿？',
    a: '宅男视频搭载自研智能加速引擎，支持多线路自动切换和智能预加载技术。当检测到当前线路波动时，系统会毫秒级切换到最优线路，确保播放始终流畅。同时接入久久视频、小蓝视频、豆花视频等多个稳定片源平台，从源头保障内容加载速度。',
  },
  {
    q: '久久视频、小蓝视频、豆花视频的内容多久更新一次？',
    a: '我们每日同步各大平台最新内容。久久视频、小蓝视频和豆花视频的热门剧集、电影、综艺通常在首播后24小时内完成同步更新，确保你第一时间看到最新资源。部分热门内容支持当天同步上架。',
  },
  {
    q: '手机和平板可以用宅男视频吗？',
    a: '当然可以！宅男视频已全面适配移动端，无论是手机还是平板，都能获得和桌面端一样流畅的高清观影体验。直接在浏览器访问即可，无需下载任何APP，简洁方便不占内存。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">常见问题</h2>
            <p className="text-sm md:text-base text-foreground-600">关于宅男视频的流畅观影体验，你可能想了解的问题</p>
          </div>
          <div className="space-y-4">
            {faqItems.map((item, i) => (
              <div key={i} className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6">
                <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.q}</h3>
                <p className="text-sm text-foreground-700 leading-relaxed">{item.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}